<template>
  <div class="wrapper">
    <span
      v-if="typeItems !== 'tour'"
      class="wrapper__btn-left"
      @click="changeSlideLeft"
      ref="iconLeft"
      ><SvgBtnArrowSvg
    /></span>
    <span
      v-if="typeItems !== 'tour'"
      class="wrapper__btn-right"
      @click="changeSlideRight"
      ref="iconRight"
      ><SvgBtnArrowSvg :right="true"
    /></span>
    <div
      class="carousel"
      @mousemove="dragging"
      @mousedown="dragStart"
      @mouseup="dragStop"
      @mouseleave="dragStop"
      @touchstart="dragStart"
      @touchmove="dragging"
      @touchend="dragStop"
      ref="videoSliderRef"
      :style="{maxWidth: maxWidthCarousel}"
    >
      <div v-if="typeItems === 'video'" class="video">
        <div v-for="(video, index) in items">
          <div
            v-if="videoRange?.includes(index) && !isMobile"
            class="loader__wrapper"
            :key="typeof video === 'string' ? video : video[0]"
            :style="{
              left: `calc(${index * firstImgWidth + 'px'}`,
              zIndex: loadVideoForStart[video[0]] ? -1 : 1,
            }"
          >
            <UiLoader
              :radius="10"
              color="var(--var-blue-100)"
              :circle-width="2"
            />
          </div>
        </div>
        <video
          v-for="(video, index) in items"
          v-if="!isReload"
          :id="video[0]"
          :key="typeof video === 'string' ? video : video[0]"
          :class="{
            'gallery-video-loop_first': index === 0,
            'gallery-video-loop': true,
          }"
          :controls="isCanControlVideo[video] || isMobile"
          autoplay
          autobuffer
          loop
          playsinline
          webkit-playinginline
          muted
          :style="{
            display: videoRange?.includes(index) ? 'unset' : 'none',
          }"
          :ref="index === 0 ? 'videoFirstRef' : undefined"
          draggable="false"
          @canplaythrough="isLoadEnoughVideo(video[0])"
          @error="handErrorLoadVideo($event, video[0])"
          @click="videoClickHandler(video[0])"
        >
          <!-- <source
            v-if="
              typeof video !== 'string' && videoRange?.includes(index)
            "
            v-for="source in video"
            :src="source"
            :key="source"
            type="video/mp4"
          /> -->
        </video>
      </div>
      <div v-else-if="typeItems === 'images'" class="images">
        <div class="loader__wrapper">
          <UiLoader
            :radius="10"
            color="var(--var-blue-100)"
            :circle-width="2"
          />
        </div>
        <img
          v-for="(images, index) in items"
          :id="images"
          @click="openInFullSizeHandler(images)"
          :key="images"
          :src="images"
          :ref="index === 0 ? 'videoFirstRef' : undefined"
          :class="{
            'gallery-video-loop_first': index === 0,
            'gallery-video-loop': true,
          }"
        />
      </div>
      <div v-else-if="typeItems === 'tour'">
        <div class="gallery-carusel-wrp">
          <div class="panorama-wrp">
            <iframe
              class="panorama-item"
              :src="baseUrl + items"
              height="100%"
              width="850px"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="typeItems !== 'tour' && !isMobile"
      class="wrapper__right-bar"
      id="wrapper__right-bar"
    >
      <div v-if="typeItems === 'video'">
        <div
          v-for="(poster, index) in posters"
          class="images__wrapper-video"
          @click="chooseItemActive(poster.videoSrc, index)"
        >
          <SvgBtnPlaySvg color="var(--var-blue-100)" />
          <img
            :src="poster.value"
            class="images__wrapper_poster"
            :class="{item_active: choosenItem === index}"
          />
        </div>
      </div>
      <div v-else-if="typeItems === 'images'">
        <div
          v-for="(images, index) in items"
          @click="chooseItemActive(images, index)"
          class="images__wrapper"
        >
          <div class="loader__wrapper">
            <UiLoader
              :radius="10"
              color="var(--var-blue-100)"
              :circle-width="2"
            />
          </div>
          <img
            v-if="!isReload"
            :src="images"
            :class="{item_active: choosenItem === index}"
          />
        </div>
      </div>
    </div>
    <UiModalsFullScreenModal
      v-if="isOpenFullScreenModal"
      :typeItems="typeItems"
      :items="items"
      :videoRange="videoRange"
      :posters="posters"
      :item-active="choosenItem"
      @close-action="closeActionHandler"
    />
  </div>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import {useRuntimeConfig} from '#imports';
import {useBaseStore} from '~/modules/BaseModule/base.store';

const props = withDefaults(
  defineProps<{
    items: any;
    posters: {videoSrc: string; value: string}[];
    typeItems: 'images' | 'video' | 'tour';
    isReload?: boolean;
    maxWidthCarousel?: string;
  }>(),
  {
    items: [],
    maxWidthCarousel: '850px',
  },
);
const runtimeConfig = useRuntimeConfig();
const base = useBaseStore();
const isMobile = computed(() => base.isMobile);
const baseUrl = runtimeConfig.public.vueAppBaseUrl;
const videoRange = ref<null | number[]>(null);
const loadVideoForStart = ref<any>({});
const videoSliderRef = ref(null);
const videoFirstRef = ref(null);
const iconLeft = ref(null);
const iconRight = ref(null);

let positionDiff: number;
let firstImgWidth: number;
let isDragStart = false;
let prevPageX: number;
let prevScrollLeft: number;
let scrollWidth: number;
let isDragging = false;
const choosenItem = ref(0);
const isCanSlide = ref(true);
const isOpenFullScreenModal = ref(false);

const closeActionHandler = () => {
  isOpenFullScreenModal.value = false;
};

const isCanControlVideo = ref<{[name: string]: boolean}>({});

const videoClickHandler = async (video: string) => {
  if (!isDragging) {
    // setTimeout(() => {
    isCanControlVideo.value = {
      [video]: !isCanControlVideo.value[video],
    };
    if (!isCanControlVideo.value[video]) {
      await document.getElementById(video)?.play();
    }
    // }, 100);
  }
};
const videoFocusHandler = (e: any, video: string) => {
  // console.log(e);
  // console.log(e.layerY);
  // console.log(e.srcElement.clientHeight);
  const currentPosition = e?.layerY > 0 ? e?.layerY : 1;
  const currentHeightItem = e?.srcElement?.clientHeight;
  // console.log((currentPosition / currentHeightItem) * 100);

  if ((currentPosition / currentHeightItem) * 100 > 30) {
    isCanControlVideo.value = {[video]: true};
  }
  // console.log(video);
  // isCanControlVideo.value = {[video]: true}
};

const openInFullSizeHandler = (item: string) => {
  if (!isDragging) {
    isOpenFullScreenModal.value = true;
  }
};

const isLoadEnoughVideo = (currentVideo: string) => {
  const video = document.getElementById(currentVideo);
  if (video) {
    setTimeout(async () => {
      // await video.play();
    }, 1000);
  }
  loadVideoForStart.value = {
    ...loadVideoForStart.value,
    [currentVideo]: true,
  };
};

const intervalLoadRef = ref<any>(null);

const handErrorLoadVideo = (e, video?: string) => {
  if (video) {
    const brokeVideo: HTMLVideoElement | null =
      document.getElementById(video) as HTMLVideoElement;
    if (brokeVideo) {
      // if (intervalLoadRef.value) {
      //   clearTimeout(intervalLoadRef.value);
      //   intervalLoadRef.value = null;
      // }
      intervalLoadRef.value = setTimeout(async () => {
        brokeVideo.pause();
        brokeVideo.load();
        // await brokeVideo.play();
      }, 3000);
    }
  }
};

const showHideIcons = (isNeedChoosenItem?: boolean) => {
  if (videoSliderRef.value) {
    if (!isNeedChoosenItem) {
      choosenItem.value = Math.round(
        videoSliderRef.value.scrollLeft / firstImgWidth,
      );
    }

    if (iconLeft.value) {
      iconLeft.value.style.display =
        videoSliderRef.value.scrollLeft <= 120 ? 'none' : 'block';
    }

    if (iconRight.value) {
      iconRight.value.style.display =
        videoSliderRef.value.scrollLeft + 20 >= scrollWidth
          ? 'none'
          : 'block';
    }
  }
};

const changeSlideLeft = () => {
  if (videoSliderRef.value && isCanSlide.value) {
    isCanSlide.value = false;
    videoSliderRef.value.scrollLeft += -firstImgWidth;
    setTimeout(() => {
      showHideIcons();
      isCanSlide.value = true;
    }, 600);
  }
};

const changeSlideRight = () => {
  // if (videoRange.value?.length !== props.items?.length) {
  //   videoRange.value = Array.from(Array(props.items.length).keys());
  // }
  if (props.typeItems === 'video') {
    props.items.forEach((video, index) => {
      const videoTag = document.getElementById(video[0]);
      if (!videoTag?.src) {
        const videoSplit = video[0].split('.');
        videoTag.src = isMobile.value
          ? `${videoSplit[0]}.${videoSplit[1]}_mobile.${videoSplit[2]}`
          : video[0];
      }
    });
  }

  if (videoSliderRef.value && isCanSlide.value) {
    isCanSlide.value = false;
    videoSliderRef.value.scrollLeft += firstImgWidth;
    setTimeout(() => {
      showHideIcons();
      isCanSlide.value = true;
    }, 600);
  }
};

const chooseItemActive = (activeItem: string, index: number) => {
  choosenItem.value = index;
  const choosenItemById = document.getElementById(activeItem);
  if (props.typeItems === 'video') {
    const videoSplit = activeItem.split('.');
    if (!choosenItemById?.src) {
      choosenItemById.src = isMobile.value
        ? `${videoSplit[0]}.${videoSplit[1]}_mobile.${videoSplit[2]}`
        : activeItem;
      setTimeout(async () => {
        await choosenItemById.play();
      }, 3000);
    }
  }

  if (choosenItemById) {
    new Promise((res) => {
      if (videoSliderRef.value) {
        videoSliderRef.value.scrollLeft = choosenItemById?.offsetLeft;
      }
      res('');
    }).then(() => {
      setTimeout(() => {
        showHideIcons(true);
      }, 1300);
    });
  }
};
const dragging = (e) => {
  if (videoSliderRef.value) {
    if (!isDragStart) return;
    e.preventDefault();
    isDragging = true;
    videoSliderRef.value.classList.add('dragging');
    positionDiff = (e.pageX || e.touches[0].pageX) - prevPageX;
    videoSliderRef.value.scrollLeft = prevScrollLeft - positionDiff;
  }
};
const autoSlide = () => {
  // if (videoRange.value?.length !== props.items?.length) {
  //   videoRange.value = Array.from(Array(props.items.length).keys());
  // }
  if (props.typeItems === 'video') {
    props.items.forEach((video, index) => {
      if (index >= 2 && !loadVideoForStart.value[video[0]]) {
        const videoTag = document.getElementById(video[0]);
        const videoSplit = video[0].split('.');
        videoTag.src = isMobile.value
          ? `${videoSplit[0]}.${videoSplit[1]}_mobile.${videoSplit[2]}`
          : video[0];
      }
    });
  }
  if (
    (videoSliderRef.value &&
      videoSliderRef.value.scrollLeft -
        (videoSliderRef.value.scrollWidth -
          videoSliderRef.value.clientWidth) >
        -1) ||
    (videoSliderRef.value && videoSliderRef.value.scrollLeft <= 0)
  ) {
    return;
  }
  positionDiff = Math.abs(positionDiff);
  const additionalValueML = isMobile.value ? 10 : 14;
  let firstImgWidth =
    videoSliderRef.value.clientWidth + additionalValueML;
  let valDifference = firstImgWidth - positionDiff;

  if (
    videoSliderRef.value &&
    videoSliderRef.value.scrollLeft > prevScrollLeft
  ) {
    return (videoSliderRef.value.scrollLeft +=
      positionDiff > firstImgWidth / 5
        ? valDifference
        : -positionDiff);
  }
  if (videoSliderRef.value) {
    return (videoSliderRef.value.scrollLeft -=
      positionDiff > firstImgWidth / 5
        ? valDifference
        : -positionDiff);
  }
};

const dragStart = (e) => {
  if (videoSliderRef.value) {
    isDragStart = true;
    prevPageX = e.pageX || e.touches[0].pageX;
    prevScrollLeft = videoSliderRef.value.scrollLeft;
  }
};
const dragStop = (e) => {
  isDragStart = false;
  // if (videoRange.value?.length !== props.items?.length) {
  //   videoRange.value = Array.from(Array(props.items.length).keys());
  // }
  if (videoSliderRef.value) {
    videoSliderRef.value.classList.remove('dragging');
    if (!isDragging) return;
    setTimeout(() => {
      isDragging = false;
    }, 0);
    new Promise((res, rej) => {
      const afterSlide = autoSlide();
      if (afterSlide % firstImgWidth !== 0) {
        videoSliderRef.value.scrollLeft =
          firstImgWidth *
          Math.round(videoSliderRef.value.scrollLeft / firstImgWidth);
      }
      res('');
    }).then(() => {
      setTimeout(() => {
        showHideIcons();
      }, 600);
    });
  }
};

watch(
  () => [props.typeItems, isMobile.value],
  () => {
    if (videoSliderRef.value) {
      if (props.typeItems === 'video') {
        setTimeout(() => {
          props.items.forEach((video, index) => {
            if (index <= 1) {
              const videoTag = document.getElementById(video[0]);
              const videoSplit = video[0].split('.');
              videoTag.src = isMobile.value
                ? `${videoSplit[0]}.${videoSplit[1]}_mobile.${videoSplit[2]}`
                : video[0];
            }
          });
        }, 100);

        if (isMobile.value) {
          videoRange.value = [0, 1];
        } else {
          videoRange.value = Array.from(
            Array(props.items.length).keys(),
          );
        }
      } else {
        loadVideoForStart.value = {};
      }
      videoSliderRef.value.scrollLeft = 0;
      setTimeout(() => {
        const additionalValueML = isMobile.value ? 10 : 14;
        firstImgWidth =
          videoSliderRef.value.clientWidth + additionalValueML;
        scrollWidth =
          videoSliderRef.value.scrollWidth -
          videoSliderRef.value.clientWidth;
      }, 100);
      setTimeout(() => {
        showHideIcons();
      }, 600);
    }
  },
);

const resizeHandler = () => {
  if (videoFirstRef.value) {
    const additionalValueML = isMobile.value ? 10 : 14;
    firstImgWidth =
      videoSliderRef.value.clientWidth + additionalValueML;
    const afterSlide = autoSlide();
    if (afterSlide % firstImgWidth !== 0) {
      videoSliderRef.value.scrollLeft =
        firstImgWidth *
        Math.round(videoSliderRef.value.scrollLeft / firstImgWidth);
    }
  }
};

onMounted(() => {
  if (isMobile.value) {
    videoRange.value = [0, 1];
  } else {
    videoRange.value = Array.from(Array(props.items.length).keys());
  }
  if (videoSliderRef.value) {
    const additionalValueML = isMobile.value ? 10 : 14;
    firstImgWidth =
      videoSliderRef.value.clientWidth + additionalValueML;
    scrollWidth =
      videoSliderRef.value.scrollWidth -
      videoSliderRef.value.clientWidth;
  }

  setTimeout(() => {
    showHideIcons();
  }, 60);

  window.onresize = resizeHandler;
});
onUnmounted(() => {
  window.onresize = null;
});
</script>

<style scoped lang="scss">
.gallery-carusel-wrp {
  .panorama-wrp {
    .panorama-item {
      height: 450px;
      border-radius: 8px;
      border: none;

      @media (max-width: $md) {
        height: 100%;
        min-height: 225px;
      }
    }
  }
}
.images__wrapper {
  position: relative;
  height: fit-content;
  min-height: 55px;
  .loader__wrapper {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;

    @media (max-width: $lg) {
      display: none;
    }
  }
}

.images__wrapper-video {
  position: relative;
  height: fit-content;
  min-height: 55px;

  svg {
    position: absolute;
    top: 24%;
    left: 30%;
    height: 30px;
    cursor: pointer;
  }
  .loader__wrapper {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;
  }
}
.gallery-carusel-wrp {
  display: flex;
  gap: 16px;

  @media (max-width: $lg) {
    flex-direction: column;
  }

  @media (max-width: 900px) {
    .gallery-carusel-wrp {
      .panorama-wrp {
        .panorama-item {
          border-radius: 8px;
          border: none;
        }
        .panorama-item {
          width: 100%;
        }
      }
    }
  }
}
.wrapper {
  max-width: 100vw;
  width: 100%;
  position: relative;
  display: flex;
  gap: $g-6;

  & span {
    top: 50%;
    height: 44px;
    width: 44px;
    color: #343f4f;
    font-size: 1.15rem;
    position: absolute;
    text-align: center;
    line-height: 44px;
    border-radius: 50%;
    transform: translateY(-50%);
    transition: transform 0.1s linear;

    z-index: 100;
    &:active {
      transform: translateY(-50%) scale(0.9);
    }
    &:hover {
      transition: all linear 0.2s;
      background: #a2a2a2;
    }
    svg {
      height: 44px;
      width: 44px;
    }
  }

  &__btn-left {
    left: 12px;
    display: none;
    justify-content: center;
    align-items: center;
  }
  &__btn-right {
    right: 290px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 1100px) {
      left: 780px;
    }
    @media (max-width: 900px) {
      right: 12px;
      left: auto;
    }
  }

  &__right-bar {
    min-width: 100px;
    max-width: 100px;
    display: flex;
    flex-direction: column;
    gap: $g-4;
    video {
      width: 100px;
      min-height: 55px;
      border-radius: $br-1;
      cursor: pointer;
    }
    img {
      width: 100px;
      min-height: 55px;
      border-radius: $br-1;
      cursor: pointer;
    }
    .item_active {
      border-radius: $br-2;
      border: 5px solid var(--var-blue-100);
      height: fit-content;
    }
  }
  .carousel {
    position: relative;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    scroll-behavior: smooth;
    border-radius: $br-3;

    .video {
      position: relative;

      .loader__wrapper {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
      }
    }

    .images {
      position: relative;
      .loader__wrapper {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: -1;
      }
    }

    img {
      height: 450px;
      width: calc(100% / 1);
      object-fit: cover;
      margin-left: $m-3;
      border-radius: $br-3;

      &:first-child {
        margin-left: 0px;
      }

      @media (max-width: $lg) {
        width: calc(100% / 1);
      }
      @media (max-width: $md) {
        width: 100%;
        height: 100%;
      }
    }
    video {
      height: 450px;
      width: calc(100% / 1);
      object-fit: cover;
      border-radius: $br-3;

      @media (max-width: $lg) {
        width: calc(100% / 1);
      }
      @media (max-width: $md) {
        width: 100%;
        height: 100%;
      }
    }

    .gallery-video-loop {
      margin-left: 14px;
      &_first {
        margin-left: 0px;
      }

      @media (max-width: $md) {
        margin-left: 10px;
        &_first {
          margin-left: 0px;
        }
      }
    }
  }
  .dragging {
    scroll-behavior: auto;

    &img {
      pointer-events: none;
      cursor: grab !important;
    }
  }
}
.dragging {
  video {
    cursor: grabbing !important;
  }
  img {
    cursor: grabbing !important;
  }
}
</style>
